// Module
var code = "<select ng-options=\"m.id as m.name for m in vm.ndsopts\"\n        ng-model=\"vm.model\"></select>\n\n<select ng-model=\"vm.ndsMode\">\n  <option value=\"\">в т.ч. НДС</option>\n  <option value=\"+\">НДС сверху</option>\n</select>";
// Exports
module.exports = code;